import { FC } from 'react';

import { NavBar } from 'common/components';
import AppLayout from 'common/components/layouts/app-layout';

import './styles.scss';
const CashoutLayout: FC = ({ children }) => {
  return <AppLayout CustomNavBar={CashoutNavBar}>{children}</AppLayout>;
};

const CashoutNavBar: FC = () => {
  return <NavBar />;
};

export default CashoutLayout;
